import mixx from "../../../../mixin/mixin.js";

export default {
  mixins: [mixx],
  name: "widgets",
  data() {
    return {
      ventas: {
        TOTAL: 0,
        CONTRACARGOS: 0,
        DEVOLUCIONES: 0,
        LIQUIDADA: 0,
        RECHAZOS: 0,
        QR:0
      },
      emailAsociado: '',
    };
  },

  mounted: function () {
    this.$root.$on("consultarw", () => {
      this.consultar();
    });

    this.consultar();
    this.getUserMail();
  },
  methods: {



    getUserMail() {
      this.$http
        .get("/config/perfil/email/")
        .then(response => {
          this.emailAsociado = response.data.mail;
        })

    },

    consultar() {
      this.$http
        .post(
          "/reportes/totales")
        .then(response => {
          if (response.data.status == 1) {
            this.ventas = response.data.data[0];

            this.$emit(
              "porventev",
              this.num_to_many(response.data.data[0].POR)
            );
          }
        });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/reportes/pagos/widgets/widgets.js